module.exports = __webpack_public_path__ + "img/index_shouyigui.7fdc5c7a.png";